// src/data/blogPosts.js
// Add new posts here — they automatically appear on /blog listing page

export const BLOG_POSTS = [
  {
    slug: 'shadow-ai-enterprise-discovery',
    title: 'Shadow AI in the Enterprise — How to Find It Before Your Board Does',
    excerpt: 'Most enterprises have dozens of AI tools running without IT knowledge. Here\'s a systematic approach to discovering, classifying, and governing shadow AI before it becomes a board-level incident.',
    date: 'March 14, 2026',
    readTime: '8 min read',
    category: 'AI Governance',
    categoryColor: '#10B981',
    categoryRgb: '16,185,129',
    author: 'RevUpAI',
    tags: ['Shadow AI', 'AI Governance', 'CISO', 'Enterprise Security'],
    featured: true,
  },
  {
    slug: 'secure-developer-ai',
    title: 'How to Secure Developer AI Tools Like Claude Code, Cursor, and Copilot',
    excerpt: 'Your developers already use AI coding agents — the engine behind "vibe coding" — that can read your codebase, reach your secrets, and ship code, usually with no review and no record. Here\'s why banning them backfires and how to govern the developer AI surface without slowing engineering down.',
    date: 'June 25, 2026',
    readTime: '6 min read',
    category: 'Developer Security',
    categoryColor: '#00D4AA',
    categoryRgb: '0,212,170',
    author: 'RevUpAI',
    tags: ['Developer Security', 'Vibe Coding Security', 'Claude Code', 'Cursor', 'GitHub Copilot', 'AI Governance', 'Operated AI'],
    featured: false,
    comingSoon: false,
  },
  {
    slug: 'what-is-ai-security-governance',
    title: 'What Is AI Security & Governance? A 2026 Enterprise Guide',
    excerpt: 'AI security and governance means knowing every AI in your enterprise, controlling what each can do, protecting your data, and proving it\'s governed. A clear guide to the surfaces, frameworks (NIST AI RMF, EU AI Act, ISO 42001), and how to discover, govern and monitor every AI.',
    date: 'June 27, 2026',
    readTime: '9 min read',
    category: 'AI Governance',
    categoryColor: '#10B981',
    categoryRgb: '16,185,129',
    author: 'RevUpAI',
    tags: ['AI Security & Governance', 'AI Governance', 'NIST AI RMF', 'EU AI Act', 'Shadow AI', 'Operated AI'],
    featured: false,
    comingSoon: false,
  },
  {
    slug: 'oracle-to-postgresql-migration-guide',
    title: 'Oracle to PostgreSQL Migration: A 2026 Enterprise Guide',
    excerpt: 'About 90–95% of an Oracle workload is mechanically convertible to PostgreSQL — the hard 5–10% (packages, autonomous transactions, CONNECT BY) needs judgment. A guide to why enterprises migrate, the constructs that make it hard, how AI agents convert and validate them, and how long it takes.',
    date: 'June 27, 2026',
    readTime: '11 min read',
    category: 'Database Migration',
    categoryColor: '#F59E0B',
    categoryRgb: '245,158,11',
    author: 'RevUpAI',
    tags: ['Oracle to PostgreSQL', 'Database Migration', 'PostgreSQL', 'AWS', 'Database Modernization', 'AI DBA'],
    featured: false,
    comingSoon: false,
  },
  {
    slug: 'data-modernisation-ai-roadmap',
    title: 'The Hidden Tax on Your AI Roadmap: Why Data Modernisation Is the Prerequisite Nobody Talks About',
    excerpt: 'Every Fortune 500 board has approved an AI budget. Most will see nothing back from it — not because the AI isn\'t ready, but because the data infrastructure isn\'t. Here\'s the hidden cost and how to fix it.',
    date: 'March 14, 2026',
    readTime: '10 min read',
    category: 'Database Migration',
    categoryColor: '#F59E0B',
    categoryRgb: '245,158,11',
    author: 'RevUpAI',
    tags: ['Data Modernisation', 'PostgreSQL', 'Database Migration', 'AI Strategy', 'Legacy Database'],
    featured: false,
    comingSoon: false,
  },
  {
    slug: 'nist-ai-rmf-practical-guide',
    title: 'NIST AI RMF — A Practical Implementation Guide for Enterprise CISOs',
    excerpt: 'The NIST AI Risk Management Framework is the most important AI governance document of 2025-2026. Here\'s how to implement it in a real enterprise without a 12-month consulting project.',
    date: 'March 14, 2026',
    readTime: '10 min read',
    category: 'AI Governance',
    categoryColor: '#10B981',
    categoryRgb: '16,185,129',
    author: 'RevUpAI',
    tags: ['NIST AI RMF', 'AI Governance', 'CISO', 'Compliance'],
    featured: false,
    comingSoon: false,
  },
];